import { HttpErrorResponse } from '@angular/common/http';
import { BadRequestParameters } from '../types/bad-request-parameters';

export class BadRequestHttpErrorResponse<
  Code,
  Parameters extends BadRequestParameters,
> {
  private constructor(
    private readonly data: {
      code: Code;
      detail: string;
      parameters: Record<Parameters, string>;
      propertyPath: string;
      template: string;
      title: string;
    },
  ) {}

  public get code(): Code {
    return this.data.code;
  }

  public get parameters(): Record<Parameters, string> {
    return this.data.parameters;
  }

  public get propertyPath(): string {
    return this.data.propertyPath;
  }

  public static fromResponse<Code, Parameters extends BadRequestParameters>(
    response: HttpErrorResponse,
  ): BadRequestHttpErrorResponse<Code, Parameters> {
    return new BadRequestHttpErrorResponse<Code, Parameters>({
      title: response.error.title,
      detail: response.error.detail,
      code: response.error.code,
      template: response.error.template,
      parameters: response.error.parameters,
      propertyPath: response.error.propertyPath,
    });
  }
}
